(function () {
  var drawer = document.querySelector("[data-size-guide-drawer]");
  if (!drawer) return;

  var img = drawer.querySelector("[data-size-guide-img]");
  var titleEl = drawer.querySelector("[data-size-guide-title]");

  function openDrawer(src, title) {
    img.src = src;
    if (title) titleEl.textContent = title;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add("is-open");
    });
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    setTimeout(function () {
      drawer.hidden = true;
    }, 300);
  }

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("[data-size-guide]");
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer(
        trigger.getAttribute("data-size-guide"),
        trigger.getAttribute("data-size-guide-title")
      );
      return;
    }
    if (e.target.closest("[data-size-guide-close]")) {
      closeDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });
})();
